import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useAtom } from 'jotai';
import { headerCenter_currentState_Atom, HeaderCenter_State } from "../store";
import { ElementPanelUtil } from "./ElementPanelUtil";
import { TerraDrawMode_Enum } from "~/components/MapDraw/TerraDrawUtil";
import { ElementType } from '~/common/typescript/models/Element';
import { showElementPanel_Atom, elementType_Atom } from './store';
import { useEffect } from "react";
import { memo } from "react";

const ElementPanel = () => {
  const { t } = useTranslation();
  const [showElementPanel, setShowElementPanel] = useAtom(showElementPanel_Atom);
  const [mode, setMode] = useAtom(elementType_Atom);
  const [currentState, setCurrentState] = useAtom(headerCenter_currentState_Atom);

  /**
   * Close panel when click outside
   */
  useEffect(() => {
    let handleOnClick = (e: any) => {
      const target = e.target as HTMLElement;
      if (!target.closest('.element-panel') && !target.closest('.element-header-item')) {
        setShowElementPanel(false);
      }
    }
    if (showElementPanel) {
      document.addEventListener('click', handleOnClick);
    }

    return () => {
      document.removeEventListener('click', handleOnClick);
    }

  }, [showElementPanel]);

  const switchMode = (newMode: ElementType) => {
    setCurrentState(HeaderCenter_State.ELEMENT);
    setMode(newMode);
    setShowElementPanel(false);

    {
      if (!window.draw?.enabled) {
        window.draw?.start();
      }
      if (newMode == ElementType.POINT) {
        window.draw.setMode(TerraDrawMode_Enum.POINT);
      } else if (newMode == ElementType.LINESTRING) {
        window.draw.setMode(TerraDrawMode_Enum.LINESTRING);
      } else if (newMode == ElementType.POLYGON) {
        window.draw.setMode(TerraDrawMode_Enum.POLYGON);
      } else if (newMode == ElementType.CIRCLE) {
        window.draw.setMode(TerraDrawMode_Enum.CIRCLE);
      } else {
        window.draw.setMode(TerraDrawMode_Enum.SELECT);
      }
    }
  }

  return <UI_Wrapper className="element-panel">
    <UI_GroupHeader>Dữ liệu</UI_GroupHeader>

    {/* Point */}
    <UI_Item_Wrapper onClick={() => {
      switchMode(ElementType.POINT);
    }}>
      <UI_Item_Icon>
        {ElementPanelUtil.getIcon(ElementType.POINT)}
      </UI_Item_Icon>
      <UI_Item_Text>{t('point')}</UI_Item_Text>
      <UI_Item_Right>
        P
      </UI_Item_Right>
    </UI_Item_Wrapper>
    {/* End point */}

    {/* Polyline */}
    <UI_Item_Wrapper onClick={() => {
      switchMode(ElementType.LINESTRING);
    }}>
      <UI_Item_Icon>
        {ElementPanelUtil.getIcon(ElementType.LINESTRING)}
      </UI_Item_Icon>
      <UI_Item_Text>{t('polyline')}</UI_Item_Text>
      <UI_Item_Right>
        L
      </UI_Item_Right>
    </UI_Item_Wrapper>
    {/* End Polyline */}
    {/* Polygon */}
    <UI_Item_Wrapper onClick={() => {
      switchMode(ElementType.POLYGON);
    }}>
      <UI_Item_Icon>
        {ElementPanelUtil.getIcon(ElementType.POLYGON)}
      </UI_Item_Icon>
      <UI_Item_Text>{t('polygon')}</UI_Item_Text>
      <UI_Item_Right>
        R
      </UI_Item_Right>
    </UI_Item_Wrapper>
    {/* End Polygon */}
    {/* Route */}
    {/* <UI_Item_Wrapper onClick={() => {
      switchMode(ElementType.ROUTE);
    }}>
      <UI_Item_Icon>
        {ElementPanelUtil.getIcon(ElementType.ROUTE)}
      </UI_Item_Icon>
      <UI_Item_Text>{t('route')}</UI_Item_Text>
      <UI_Item_Right>
        O
      </UI_Item_Right>
    </UI_Item_Wrapper> */}
    {/* End Route */}
    {/* Circle */}
    {/* <UI_Item_Wrapper onClick={() => {
      switchMode(ElementType.CIRCLE);
    }}>
      <UI_Item_Icon>
        {ElementPanelUtil.getIcon(ElementType.CIRCLE)}
      </UI_Item_Icon>
      <UI_Item_Text>{t('circle')}</UI_Item_Text>
      <UI_Item_Right>
        I
      </UI_Item_Right>
    </UI_Item_Wrapper> */}
    {/* End Circle */}


    {/* SAM */}
    {/* <UI_Item_Wrapper onClick={() => {
      switchMode(ElementType.SAM);
    }}>
      <UI_Item_Icon>
        {ElementPanelUtil.getIcon(ElementType.SAM)}
      </UI_Item_Icon>
      <UI_Item_Text>Auto vùng chấm điểm</UI_Item_Text>
      <UI_Item_Right>
        S
      </UI_Item_Right>
    </UI_Item_Wrapper> */}
    {/* End SAM */}
    {/* Chat SAM */}
    {/* <UI_Item_Wrapper onClick={() => {
      switchMode(ElementType.CHAT_SAM);
    }}>
      <UI_Item_Icon>
        {ElementPanelUtil.getIcon(ElementType.CHAT_SAM)}
      </UI_Item_Icon>
      <UI_Item_Text>Auto vùng nhập nhãn</UI_Item_Text>
      <UI_Item_Right>
        S
      </UI_Item_Right>
    </UI_Item_Wrapper> */}
    {/* End Chat SAM */}
    {/* <UI_GroupHeader>Đánh dấu</UI_GroupHeader> */}
    {/* Marker */}
    {/* <UI_Item_Wrapper onClick={() => {
      switchMode(ElementType.MARKER);
    }}>
      <UI_Item_Icon>
        {ElementPanelUtil.getIcon(ElementType.MARKER)}
      </UI_Item_Icon>
      <UI_Item_Text>{t('marker')}</UI_Item_Text>
      <UI_Item_Right>
        M
      </UI_Item_Right>
    </UI_Item_Wrapper> */}
    {/* End Marker */}
    {/* Highlighter */}
    {/* <UI_Item_Wrapper onClick={() => {
      switchMode(ElementType.HIGHLIGHTER);
    }}>
      <UI_Item_Icon>
        {ElementPanelUtil.getIcon(ElementType.HIGHLIGHTER)}
      </UI_Item_Icon>
      <UI_Item_Text>{t('highlighter')}</UI_Item_Text>
      <UI_Item_Right>
        H
      </UI_Item_Right>
    </UI_Item_Wrapper> */}
    {/* End highlighter */}
    {/* Block text */}
    {/* <UI_Item_Wrapper onClick={() => {
      switchMode(ElementType.BLOCK_TEXT);
    }}>
      <UI_Item_Icon>
        {ElementPanelUtil.getIcon(ElementType.BLOCK_TEXT)}
      </UI_Item_Icon>
      <UI_Item_Text>{t('block_text')}</UI_Item_Text>
      <UI_Item_Right>
        T
      </UI_Item_Right>
    </UI_Item_Wrapper> */}
    {/* End Block text */}
    {/* Note */}
    {/* <UI_Item_Wrapper onClick={() => {
      switchMode(ElementType.NOTE);
    }}>
      <UI_Item_Icon>
        {ElementPanelUtil.getIcon(ElementType.NOTE)}
      </UI_Item_Icon>
      <UI_Item_Text>{t('note')}</UI_Item_Text>
      <UI_Item_Right>
        N
      </UI_Item_Right>
    </UI_Item_Wrapper> */}
    {/* End Note */}
    {/* Link */}
    {/* <UI_Item_Wrapper onClick={() => {
      switchMode(ElementType.LINK);
    }}>
      <UI_Item_Icon>
        {ElementPanelUtil.getIcon(ElementType.LINK)}
      </UI_Item_Icon>
      <UI_Item_Text>{t('link')}</UI_Item_Text>
      <UI_Item_Right>
        K
      </UI_Item_Right>
    </UI_Item_Wrapper> */}
    {/* End Link */}
    {/* Video */}
    {/* <UI_Item_Wrapper onClick={() => {
      switchMode(ElementType.VIDEO);
    }}>
      <UI_Item_Icon>
        {ElementPanelUtil.getIcon(ElementType.VIDEO)}
      </UI_Item_Icon>
      <UI_Item_Text>Video</UI_Item_Text>
      <UI_Item_Right>
        V
      </UI_Item_Right>
    </UI_Item_Wrapper> */}
    {/* End Video */}
  </UI_Wrapper>;
}

export default memo(ElementPanel);

const UI_Wrapper = styled.div`
  position: absolute;
  width: 200px;
  background: white;
  color: black;
  top: calc(100% + 10px);
  left: 0;
  border-radius: 8px;
  background-color: rgba(255,255,255, 0.8);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadows-paneShadow);
`

const UI_GroupHeader = styled.div`
  color: #666666;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
  padding: 8px 8px;
`;

const UI_Item_Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  height: 35px;
  padding: 0px 16px;
  &:hover {
    background-color: #f0f0f0;
  }
`
const UI_Item_Icon = styled.div`
  width: 28px;
`;
const UI_Item_Text = styled.div`
  flex: 1;
  font-size: 12px;
`;

const UI_Item_Right = styled.div`
  width: 20px;
  text-align: right;
  font-size: 12px;
  color: #666666;
`